exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vuetable-pagination-info{margin-top:auto;margin-bottom:auto}", ""]);

// exports
